import React from 'react';
import './ImageLinkForm.css';

const ImageLinkForm = ({ onInputChange, onButtonSubmit }) => {
  return (
    <div>
      <p className='f3'>
        {'This Magic Brain will detect faces in your pictures. Give it a try!'}
      </p>
      <div className='center'>
        <div className='center form pa4 br3 shadow-5'>
          <input
            className='f4 pa2 w-70 center detect-input'
            type='text'
            onChange={onInputChange}
            placeholder={'Enter image URL'}
          />
          <input
            className='w-30 f4 link ph3 pv2 pointer dib detect-button'
            onClick={onButtonSubmit}
            type='submit'
            value='Detect'
          />
        </div>
      </div>
    </div>
  );
};

export default ImageLinkForm;
